import { render, staticRenderFns } from "./list-column.vue?vue&type=template&id=afbbca06&scoped=true&lang=html"
import script from "./list-column.vue?vue&type=script&lang=js"
export * from "./list-column.vue?vue&type=script&lang=js"
import style0 from "./list-column.vue?vue&type=style&index=0&id=afbbca06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbbca06",
  null
  
)

export default component.exports